import { useTranslation } from "react-i18next";
import { PiHandArrowDown } from "react-icons/pi";
import { FaUserInjured } from "react-icons/fa6";
import { Invoice } from "src/types";

interface InvoiceSubheaderProps {
    invoice: Invoice;
    recipientFullName: string;
    patientFullName: string;
    navigate: (path: string, options?: { state?: any }) => void;
}

export function InvoiceSubheader({ invoice, recipientFullName, patientFullName, navigate }: InvoiceSubheaderProps) {
    const { t } = useTranslation();

    if (invoice.recipientIsPatient) {
        const meta = [
            invoice.recipient?.email,
            invoice.recipient?.tel?.join(", "),
            invoice.patient?.birthDate ? new Date(invoice.patient.birthDate).toLocaleDateString() : null,
        ].filter(Boolean).join(" · ");

        return (
            <div className="detail-subheader__section detail-subheader__section--same-person">
                <PiHandArrowDown className="detail-subheader__icon" />
                <div className="detail-subheader__body">
                    <div className="detail-subheader__role">{t("invoicePage.roleRecipient")}</div>
                    <div className="detail-subheader__name-row">
                        <span
                            className={`detail-subheader__name${!invoice.recipient ? " detail-subheader__name--plain" : ""}`}
                            onClick={() => {
                                const r = invoice.recipient;
                                if (r) navigate(`/patients/${r.id}`);
                            }}
                        >
                            {recipientFullName || t("invoicePage.noRecipient")}
                        </span>
                        <span className="detail-subheader__same-badge">
                            <FaUserInjured /> {t("invoicePage.samePersonBadge")}
                        </span>
                    </div>
                    {meta && <span className="detail-subheader__meta">{meta}</span>}
                    {invoice.patient && (
                        <span
                            className="detail-subheader__patient-link"
                            onClick={() => {
                                if (invoice.recipient) navigate(`/patients/${invoice.recipient.id}`);
                            }}
                        >
                            {t("invoicePage.viewPatient")} →
                        </span>
                    )}
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="detail-subheader__section detail-subheader__section--recipient">
                <PiHandArrowDown className="detail-subheader__icon" />
                <div className="detail-subheader__body">
                    <div className="detail-subheader__role">{t("invoicePage.roleRecipient")}</div>
                    <span
                        className={`detail-subheader__name${!invoice.recipient ? " detail-subheader__name--plain" : ""}`}
                        onClick={() => {
                            const r = invoice.recipient;
                            if (r) navigate(`/patients/${r.id}`, { state: { tab: "recipient" } });
                        }}
                    >
                        {recipientFullName || t("invoicePage.noRecipient")}
                    </span>
                    {invoice.recipient && (
                        <span className="detail-subheader__meta">
                            {[invoice.recipient.email, invoice.recipient.tel?.join(", ")].filter(Boolean).join(" · ")}
                        </span>
                    )}
                </div>
            </div>
            <div className="detail-subheader__section detail-subheader__section--patient">
                <FaUserInjured className="detail-subheader__icon" />
                <div className="detail-subheader__body">
                    <div className="detail-subheader__role">{t("invoicePage.rolePatient")}</div>
                    <span
                        className={`detail-subheader__name${!invoice.patient ? " detail-subheader__name--plain" : ""}`}
                        onClick={() => {
                            if (invoice.recipient) navigate(`/patients/${invoice.recipient.id}`, { state: { tab: "patients" } });
                        }}
                    >
                        {patientFullName || t("invoicePage.noPatient")}
                    </span>
                    {invoice.patient && (
                        <span className="detail-subheader__meta">
                            {invoice.patient.birthDate ? new Date(invoice.patient.birthDate).toLocaleDateString() : ""}
                            {invoice.patient.email ? ` · ${invoice.patient.email}` : ""}
                        </span>
                    )}
                </div>
            </div>
        </>
    );
}
